var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavHonors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.9458 8.61398C1.68476 8.37257 1.82656 7.93616 2.17964 7.8943L7.18262 7.30089C7.32652 7.28383 7.45151 7.19346 7.51221 7.06187L9.6224 2.48705C9.77132 2.16419 10.2303 2.16413 10.3792 2.48699L12.4894 7.06178C12.5501 7.19336 12.6743 7.28397 12.8182 7.30104L17.8215 7.8943C18.1745 7.93616 18.3159 8.3727 18.0549 8.61411L14.3565 12.0349C14.2501 12.1333 14.2027 12.2798 14.231 12.4219L15.2125 17.3633C15.2818 17.712 14.9107 17.9822 14.6004 17.8086L10.2043 15.3472C10.0778 15.2764 9.92422 15.2767 9.79777 15.3475L5.4012 17.8079C5.09094 17.9816 4.71912 17.712 4.78841 17.3633L5.77012 12.4222C5.79836 12.2801 5.75111 12.1333 5.64472 12.0349L1.9458 8.61398Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavHonors);
export default __webpack_public_path__ + "static/media/nav-honors.e96c90bf9ad48369d965cbac2fd6e24f.svg";
export { ForwardRef as ReactComponent };